module.exports = __webpack_public_path__ + "static/media/feature.6f931d74.jpg";